import { render, staticRenderFns } from "./UploadFileBtn.vue?vue&type=template&id=1e1aba12&scoped=true"
import script from "./UploadFileBtn.vue?vue&type=script&lang=js"
export * from "./UploadFileBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1aba12",
  null
  
)

export default component.exports